import React from "react";
import Icon from "./Icon";

const Button = ({ text, disabled, secondary, fixedWidth, icon, onClick }) => {
  return (
    <button
      disabled={disabled}
      className={`uk-button ${
        fixedWidth ? "fixed-width-btn uk-text-center" : " "
      } ${secondary ? "prev" : "next"}`}
      onClick={onClick}
    >
      {icon && <Icon iconName={icon} />}
      <span className={`${icon ? "uk-margin-small-left" : ""}`}>{text}</span>
    </button>
  );
};
export default Button;
